export default __webpack_public_path__ + "static/media/BOOKONOURSITE.a8db0423.svg";